import React from 'react'
import PropTypes from 'prop-types'
import Provider from 'model/provider/provider'
import { PROVIDERS_PATH } from 'constants/routes'

import {
  Row as StyledRow,
  Data,
  Image,
  MainInfo,
  Name,
  NameWrap
} from 'ui/entities/styled'
import provider_default from 'assets/provider_default.png'
import EntityRating from 'components/EntityRating'
import EntityTypes from 'components/EntityTypes'
import EntityVerified from 'components/EntityVerified'
import EntitySelectButtons from 'components/EntitySelectButtons'
import ProviderBadges from 'components/ProviderBadges'
import ProviderTier from './ProviderItem/ProviderTier'
import ProviderAddress from './ProviderItem/ProviderAddress'

const ProviderItem = ({
  index,
  provider,
  onSelectEntity = () => {},
  onRemoveEntity = () => {},
  isCarePlan = false,
  isSelectionMode = false,
  isSelected = false,
  addButtonText
}) => (
  <StyledRow data-test="providerItem">
    <Image>
      <img
        src={provider.image_url}
        alt="provider"
        data-test="providerItem.image"
        onError={({ currentTarget }) => {
          currentTarget.onerror = null // prevents looping
          currentTarget.src = provider_default
        }}
      />
    </Image>
    <MainInfo>
      <NameWrap>
        <Name
          href={`${PROVIDERS_PATH}/${provider.id}`}
          target={isCarePlan ? '_blank' : '_self'}
          data-test="providerName"
        >
          {index}. {provider.full_name}
        </Name>
        <EntityVerified entity={provider} dataTest="providerVerification" />
        <ProviderTier provider={provider} />
      </NameWrap>
      <EntityRating entity={provider} dataTest="providerRating" />
      <EntityTypes
        entity={provider}
        dataTest="providerTypes"
        sourceField="specialty_names"
        length={2}
        isBsmh={provider?.source === 'bsmh'}
      />
      <ProviderBadges provider={provider} />
      {isSelectionMode && (
        <ProviderAddress
          provider={provider}
          isSelectionMode={isSelectionMode}
        />
      )}
    </MainInfo>
    <Data data-test="providerItemData">
      {isSelectionMode ? (
        <EntitySelectButtons
          entity={provider}
          isSelected={isSelected}
          onSelectEntity={onSelectEntity}
          onRemoveEntity={onRemoveEntity}
          addText={addButtonText}
        />
      ) : (
        <ProviderAddress provider={provider} />
      )}
    </Data>
  </StyledRow>
)

ProviderItem.propTypes = {
  index: PropTypes.number.isRequired,
  provider: PropTypes.instanceOf(Provider).isRequired,
  addButtonText: PropTypes.string.isRequired,
  isCarePlan: PropTypes.bool,
  isSelectionMode: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelectEntity: PropTypes.func,
  onRemoveEntity: PropTypes.func
}

export default ProviderItem
